import { render, staticRenderFns } from "./AddMsg.vue?vue&type=template&id=6fc0f54a&scoped=true"
import script from "./AddMsg.vue?vue&type=script&lang=js"
export * from "./AddMsg.vue?vue&type=script&lang=js"
import style0 from "./AddMsg.vue?vue&type=style&index=0&id=6fc0f54a&prod&lang=scss&scoped=true"
import style1 from "./AddMsg.vue?vue&type=style&index=1&id=6fc0f54a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc0f54a",
  null
  
)

export default component.exports